const selectShops = (state) => state.shops;

export default selectShops;